module.exports = __webpack_public_path__ + "img/legalServices-5.3d330dd8.png";